import { computed, type ComputedRef } from 'vue';
import { useAuthStore } from '@/stores/authStore';

export interface AdminSection {
  to: string;
  icon: string;
  labelKey: string;
}

// rbac 3.1 Interface visibility: the one place that decides which management
// interfaces a role is offered. Sidebar (desktop) and profile menu (phone)
// both render this list, so the platforms cannot drift apart (UV2).
export function useAdminSections(): ComputedRef<AdminSection[]> {
  const authStore = useAuthStore();

  return computed(() => {
    const sections: AdminSection[] = [];
    if (authStore.hasAdminAccess) {
      sections.push({ to: '/admin/tenants', icon: 'pi-building', labelKey: 'admin.tenants' });
    }
    if (authStore.canAccessAdminUsers) {
      sections.push({ to: '/admin/users', icon: 'pi-users', labelKey: 'admin.users' });
    }
    if (authStore.canAccessAdminDevices) {
      sections.push({ to: '/admin/devices', icon: 'pi-server', labelKey: 'admin.devices' });
    }
    if (authStore.canSeeSystemStatus) {
      sections.push({ to: '/3dnjud7f', icon: 'pi-chart-bar', labelKey: 'navigation.system_status' });
    }
    return sections;
  });
}
